import React from 'react';

// Componente de erro para usuário não registrado
export default function UserNotRegisteredError() {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-black text-red-500 font-mono p-4">
            <div className="border-2 border-red-500 p-8 rounded-xl holographic">
                <h1 className="text-3xl font-bold tracking-tighter mb-4">ACESSO NEGADO</h1>
                <p className="text-gray-400 uppercase tracking-widest text-sm">
                    Usuário não identificado nos registros do núcleo ORION.
                </p>
                <button
                    onClick={() => window.location.href = '/'}
                    className="mt-6 px-6 py-2 bg-red-900/30 border border-red-500 text-red-400 hover:bg-red-500 hover:text-white transition-all"
                >
                    REINICIAR TERMINAL
                </button>
            </div>
        </div>
    );
}